import { addQuery, getFileExtension } from '../url';
import { IN_BATCH_WATERMARK_WHITELIST } from '/@/enums/cacheEnum';

const WATERMARKABLE_IMAGE_EXT = ['png', 'jpg', 'jpeg', 'webp'];
const MAX_WATERMARK_FILE_SIZE = 1024 * 1024 * 35;

// 不同断点下的水印
const endPointsWatermarks = [
  {
    // 240
    range: [0, 320],
    key: 'cHVibGljL2FpLXdhdGVybWFya18yNDAucG5n',
  },
  {
    // 400
    range: [321, 500],
    key: 'cHVibGljL2FpLXdhdGVybWFya180MDAucG5n',
  },
  {
    // 600
    range: [0, 800],
    key: 'cHVibGljL2FpLXdhdGVybWFya182MDAucG5n',
  },
  {
    // 1000
    range: [801, 1300],
    key: 'cHVibGljL2FpLXdhdGVybWFya18xMDAwLnBuZw==',
  },
  {
    // 1600
    range: [1301, 2100],
    key: 'cHVibGljL2FpLXdhdGVybWFya18xNjAwLnBuZw==',
  },
  {
    // 2600
    range: [2101, Infinity],
    key: 'cHVibGljL2FpLXdhdGVybWFya18xNjAwLnBuZw==',
    // key: 'cHVibGljL2FpLXdhdGVybWFya18yNjAwLnBuZw==',
  },
];

export function getFillWatermark(w?: number, h?: number) {
  const longSize = !w || !h ? 1000 : Math.max(w, h);
  const target = endPointsWatermarks.find(({ range }) => {
    return longSize >= range[0] && longSize <= range[1];
  })!;
  return target?.key || 'cHVibGljL2FpLXdhdGVybWFya18xMDAwLnBuZw==';
}

export function isWatermarkableImage(url: string) {
  return WATERMARKABLE_IMAGE_EXT.includes(getFileExtension(url));
}

export function applyOssWatermarkUrl(url: string, width?: number, height?: number) {
  if (!isWatermarkableImage(url) || localStorage.getItem(IN_BATCH_WATERMARK_WHITELIST) === 'true') {
    return url;
  }

  return addQuery(
    url,
    `x-oss-process=image/watermark,image_${getFillWatermark(width, height)},x_8,y_8`
  );
}

/** 展示用水印 URL，同步拼接，不请求 image/info */
export function getWatermarkedDisplayUrl(
  url: string,
  options?: { fileSize?: number; width?: number; height?: number }
) {
  if (!url || !isWatermarkableImage(url)) {
    return url;
  }
  if (options?.fileSize && options.fileSize > MAX_WATERMARK_FILE_SIZE) {
    return url;
  }
  return applyOssWatermarkUrl(url, options?.width, options?.height);
}

export async function addOssWatermarkUrl(options: {
  url: string;
  width?: number;
  height?: number;
  size?: number;
}): Promise<string> {
  const url = options.url;
  if (
    !isWatermarkableImage(options.url) ||
    localStorage.getItem(IN_BATCH_WATERMARK_WHITELIST) === 'true'
  ) {
    return url;
  }

  const { width, height, size } = options;

  if (width && height && size) {
    if (size < MAX_WATERMARK_FILE_SIZE) {
      return applyOssWatermarkUrl(url, width, height);
    }
    return url;
  }

  try {
    const res = await fetch(addQuery(url, '?x-oss-process=image/info'));
    const { FileSize, ImageWidth, ImageHeight } = await res.json();
    if (Number(FileSize?.value) < MAX_WATERMARK_FILE_SIZE) {
      return applyOssWatermarkUrl(url, ImageWidth?.value, ImageHeight?.value);
    }
  } catch (e) {
    console.error(e);
  }

  return url;
}
